import { useOutletContext, Link } from 'react-router-dom';

const labels: Record<string, string> = {
  'tech-inventory': 'Technical Inventory',
  'qa-tracker': 'Q&A Tracker',
  'data-mapping': 'Data Mapping',
  'action-tracker': 'Action Tracker',
  'asana-board': 'Project Delivery Board',
  'open-items': 'Open Items',
  'mi-sherpa': 'MI Sherpa',
  'pr-review': 'PR Review',
};

export default function Overview() {
  const { clientSlug, modules } = useOutletContext<{ clientSlug: string; modules: string[] }>();
  return (
    <div>
      <h1 style={{ color: 'var(--mi-navy)' }}>Workspace</h1>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16, marginTop: 16 }}>
        {modules.length === 0 && <div className="card">No modules enabled yet.</div>}
        {modules.map((m) => (
          <Link key={m} to={`/${clientSlug}/${m}`} className="card" style={{ color: 'inherit', textDecoration: 'none' }}>
            <h3 style={{ color: 'var(--mi-navy)', marginTop: 0 }}>{labels[m] ?? m}</h3>
            <p style={{ color: 'var(--mi-muted)' }}>Open module →</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
